import deburr from "lodash/deburr";
import React, { useState } from "react";
import InputSearch from "../InputSearch";
import SupplyPointListItem from "../SupplyPointListItem";
import { styleBlock } from "../styleBlock";
const style = styleBlock("supply-point-list");
const SupplyPointListSelect = props => {
    const [filterValue, setFilterValue] = useState("");
    const groupLabel = props.translateFunc("supply_point_list");
    const searchString = filterValue && deburr(filterValue.toLowerCase());
    const matchesSearch = (attribute) => attribute && deburr(attribute.toLowerCase()).includes(searchString);
    const filteredSupplyPoints = searchString
        ? props.supplyPoints.filter(x => matchesSearch(x.title) ||
            matchesSearch(x.address) ||
            matchesSearch(x.contractExternalId) ||
            matchesSearch(x.accountExternalId) ||
            matchesSearch(x.code))
        : props.supplyPoints;
    return (React.createElement("div", { className: style.mix(props.className) },
        props.search && (React.createElement(React.Fragment, null,
            React.createElement(InputSearch, { "aria-label": "Hledat n\u00E1zev, adresu, \u010D\u00EDslo smlouvy, \u010D\u00EDslo \u00FA\u010Dtu, EAN, EIC", type: "text", size: "sm", value: filterValue, onChange: (e) => setFilterValue(e.target.value), placeholder: "Hledat název, adresu, číslo smlouvy, číslo účtu, EAN, EIC", translateFunc: props.translateFunc }))),
        React.createElement("fieldset", { className: style("fieldset") },
            React.createElement("legend", { className: "sr-only" }, groupLabel),
            React.createElement("div", { className: style("container") }, filteredSupplyPoints.map(item => (React.createElement(SupplyPointListItem, { key: item.id, data: item, selected: props.selected.includes(item.id), blue: true, onClick: () => {
                    props.onToggle(item.id);
                }, translateFunc: props.translateFunc })))))));
};
SupplyPointListSelect.defaultProps = {
    search: true,
};
export default SupplyPointListSelect;
//# sourceMappingURL=index.js.map